module.exports = __webpack_public_path__ + "static/fonts/Helios.5cd0228.ttf";